import TextWithHint from './TextWithHint';

export default TextWithHint;
